module.exports = __webpack_public_path__ + "static/img/index1.f628fad.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/index1.png
// module id = gikw
// module chunks = 7